import { Link, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { useCatalog } from '../context/CatalogContext';
import { ProductCard } from '../components/ProductCard';
import { TypeTheme } from '../lib/types';
import { grad } from '../components/ui';

export function Home() {
  const navigate = useNavigate();
  const { user } = useApp();
  const { loading, banners, exams, categories, getBestsellers, getFreeProducts } = useCatalog();
  const first = (user?.name ?? 'Learner').split(' ')[0];

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div>
      {/* hero */}
      <div className="hero" style={{ ...grad(['#5A2D9C', '#7C4DBE']), marginTop: 20 }}>
        <div className="row" style={{ justifyContent: 'space-between' }}>
          <div>
            <h1 style={{ fontSize: 24, fontWeight: 900 }}>Hi, {first} 👋</h1>
            <p style={{ opacity: 0.9, marginTop: 4 }}>What do you want to learn today?</p>
          </div>
        </div>
        <button
          onClick={() => navigate('/store')}
          style={{ marginTop: 18, width: '100%', textAlign: 'left', border: 'none', background: 'var(--surface)', borderRadius: 12, padding: '13px 16px', color: 'var(--faint)', fontSize: 15 }}
        >
          🔍 Search notes, PYQs, test series…
        </button>
      </div>

      {/* exams */}
      <div className="rail" style={{ marginTop: 20 }}>
        {exams.map((e) => (
          <Link
            key={e.id}
            to={`/store?exam=${e.id}`}
            style={{ flex: '0 0 auto', width: 82, textAlign: 'center' }}
          >
            <div className="center" style={{ width: 60, height: 60, borderRadius: 14, background: e.color + '20', fontSize: 26, margin: '0 auto' }}>
              {e.emoji}
            </div>
            <div className="muted" style={{ fontSize: 12, fontWeight: 600, marginTop: 6 }}>{e.name}</div>
          </Link>
        ))}
      </div>

      {/* banners */}
      <div className="rail" style={{ marginTop: 20 }}>
        {banners.map((b) => (
          <Link key={b.id} to={`/product/${b.productId}`} className="hero" style={{ ...grad(b.gradient), flex: '0 0 88%', maxWidth: 520, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <h3 style={{ fontSize: 20, fontWeight: 900 }}>{b.title}</h3>
              <p style={{ opacity: 0.9, marginTop: 4 }}>{b.subtitle}</p>
              <span className="btn btn-sm" style={{ background: '#fff', color: '#14121a', marginTop: 12 }}>{b.cta} →</span>
            </div>
            <div style={{ fontSize: 54 }}>{b.emoji}</div>
          </Link>
        ))}
      </div>

      {/* categories */}
      <section className="section">
        <div className="section-head"><h2 className="section-title">Browse by category</h2></div>
        <div className="grid grid-cat">
          {categories.map((c) => {
            const t = TypeTheme[c.type];
            return (
              <Link key={c.id} to={`/category/${c.type}`} className="card col gap8">
                <div className="thumb" style={{ ...grad(t.gradient), width: 44, height: 44, fontSize: 22 }}>{t.icon}</div>
                <div style={{ fontWeight: 800, marginTop: 6 }}>{c.title}</div>
                <div className="muted" style={{ fontSize: 12 }}>{c.tagline}</div>
              </Link>
            );
          })}
        </div>
      </section>

      {/* bestsellers */}
      <section className="section">
        <div className="section-head">
          <h2 className="section-title">🔥 Bestsellers</h2>
          <Link to="/store" className="link">See all ›</Link>
        </div>
        <div className="rail">
          {getBestsellers().map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </section>

      {/* free */}
      <section className="section">
        <div className="section-head"><h2 className="section-title">🎁 Free resources</h2></div>
        <div className="rail">
          {getFreeProducts().map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </section>

      {/* promo */}
      <section className="section">
        <div className="card row" style={{ background: 'var(--accent-soft)', justifyContent: 'space-between' }}>
          <div>
            <span className="badge" style={{ background: '#ff6b3520', color: 'var(--accent)' }}>LIMITED OFFER</span>
            <div style={{ fontWeight: 800, marginTop: 8 }}>Get any 3 packs & save 25%</div>
            <div className="muted" style={{ fontSize: 14 }}>Bundle notes + PYQs + test series</div>
          </div>
          <div style={{ fontSize: 42 }}>🎯</div>
        </div>
      </section>
    </div>
  );
}
